import { call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  loadReconciliationTransactionsSuccess,
  loadReconciliationTransactionsFailure,
} from '../actions';
import {
  loadReconciliationTransactions,
  LoadReconciliationTransactionsResponse,
} from '../api';
import { LoadReconciliationTransactionsRequestAction } from '../types';

export function* loadReconciliationTransactionsSaga(
  action: LoadReconciliationTransactionsRequestAction
) {
  try {
    const { connectionId, mappingId, dataLogId, reportId } = action.payload;

    const response: LoadReconciliationTransactionsResponse = yield call(
      loadReconciliationTransactions,
      connectionId,
      mappingId,
      dataLogId,
      reportId
    );
    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(loadReconciliationTransactionsSuccess(response.data));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(loadReconciliationTransactionsFailure());
  }
}
